import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { States } from "../../../../constants";
import { developerApplicationSelector } from "../../../../store";
import { setApplicantInformation } from "../../../../store/DeveloperApplication/ApplicantInformation";
import Button from "../../../UI/Button";
import CheckboxField from "../../../UI/Form/CheckboxField";
import InputField from "../../../UI/Form/InputField";
import EinFormat from "../../../UI/Form/InputFormat/EinFormat";
import PhoneNumberFormat from "../../../UI/Form/InputFormat/PhoneNumberFormat";
import MaskedInputField from "../../../UI/Form/MaskedInputField";
import SelectField from "../../../UI/Form/SelectField";
import { anyApply, validationSchema } from "./constant";

export default function ApplicantInformation({
  nextHandler,
  previousHandler,
}: {
  nextHandler: () => void;
  previousHandler: () => void;
}) {
  const dispatch = useDispatch();
  const { applicantInformation } = useSelector(developerApplicationSelector);
  const [formErrors, setFormErrors] = useState("");

  const {
    register,
    handleSubmit,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: applicantInformation,
    resolver: yupResolver(validationSchema),
    mode: "all",
  });

  const onSubmit = (data: any) => {
    dispatch(
      setApplicantInformation({
        ...data,
        applicantInfoIsValid: true,
        formationDate: getValues("formationDate"),
      })
    );
    nextHandler();
  };

  const onError = () => {
    setFormErrors("Form is invalid. Please fix the highlighted form fields.");
    dispatch(setApplicantInformation({ setApplicantInfoIsValid: false }));
  };

  const onPreviousHandler = () => {
    previousHandler();
    // trigger().then((isValid) => {
    //   if (isValid) {
    //   } else {
    //     onError();
    //   }
    // });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div className="sm:rounded-r-md sm:overflow-hidden">
        <div className="py-6 px-4 space-y-6 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-green-500">
            Applicant Information
          </h3>
          <div className="grid grid-cols-6 gap-6">
            <InputField
              customClassName="col-span-3"
              label="Entity Name"
              name="entityName"
              type="text"
              error={errors.entityName?.message}
              register={register}
            />
            <MaskedInputField
              customClassName="col-span-6 sm:col-span-3"
              label="EIN"
              name="ein"
              id="ein"
              error={errors.ein?.message}
              control={control}
              MaskComponent={EinFormat}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-3"
              label="Contact Person Full Name"
              name="contactPersonName"
              type="text"
              error={errors.contactPersonName?.message}
              register={register}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-3"
              label="Contact Person Email"
              name="contactPersonEmail"
              type="email"
              placeholder="myemail@example.com"
              error={errors.contactPersonEmail?.message}
              register={register}
            />
            <InputField
              customClassName="col-span-6"
              label="Street Address"
              name="streetAddress"
              type="text"
              error={errors.streetAddress?.message}
              register={register}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="City"
              name="city"
              type="text"
              error={errors.city?.message}
              register={register}
            />
            <SelectField
              customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
              label="State / Province"
              name="state"
              error={errors.state?.message}
              register={register}
            >
              <option>Select</option>
              {States.map((state) => (
                <option key={state.abbreviation} value={state.name}>
                  {state.name}
                </option>
              ))}
            </SelectField>
            <InputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="ZIP / Postal code"
              name="zipCode"
              type="number"
              error={errors.zipCode?.message}
              register={register}
            />
            <MaskedInputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="Phone Number"
              name="phone"
              id="phone"
              error={errors.phone?.message}
              control={control}
              MaskComponent={PhoneNumberFormat}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="Website (if available)"
              name="website"
              type="text"
              placeholder="mywebsite.com"
              error={errors.website?.message}
              register={register}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="Formation Date"
              name="formationDate"
              type="date"
              error={errors.formationDate?.message}
              register={register}
            />
            <InputField
              customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
              label="Number of Full Time Employees"
              name="fullTimeEmployeeCount"
              type="number"
              error={errors.fullTimeEmployeeCount?.message}
              register={register}
            />
          </div>
          <div>
            <CheckboxField
              label="Check any of the following that apply:"
              name="anyApply"
              fieldOptions={anyApply}
              register={register}
            />
          </div>
          <p className="text-tertiaryColor-normal text-md">{formErrors}</p>
          <div className="flex gap-4 justify-end mt-5">
            <Button
              label="Previous"
              btnStyle="btn-neutral"
              type="button"
              onClick={onPreviousHandler}
            />
            <Button label="Next" btnStyle="btn-primary" type="submit" />
          </div>
        </div>
      </div>
    </form>
  );
}
